import { FoodTypesDto } from "@gtpl/shared-models/masters";
import { GradeSuggestion } from "../grade-suggestion.entity";
import { GradeSuggestionDTO } from "./grade-suggestion.dto";

export class GradeSuggestionAdapter {
    convertDtoToEntity(dtoObj: GradeSuggestionDTO,  isUpdate: boolean = false ): GradeSuggestion {
        try {
            const entityObj = new GradeSuggestion();
            entityObj.createdUser = dtoObj.createdUser;
            entityObj.minGrade = dtoObj.minGrade;
            entityObj.maxGrade = dtoObj.maxGrade;
            entityObj.productId = dtoObj.productId;
            entityObj.plantId =dtoObj.plantId;
            entityObj.priority = dtoObj.priority;
            entityObj.saleOrderId = dtoObj.saleOrderId;
            entityObj.plannedQuantity = dtoObj.plannedQuantity;
            entityObj.sequence = dtoObj.sequence;
            entityObj.date = dtoObj.date;
            if (dtoObj.gradeSuggestionId) {
                entityObj.gradeSuggestionId = dtoObj.gradeSuggestionId;
                entityObj.updatedUser = dtoObj.updatedUser;
            }
            entityObj.isActive = dtoObj.isActive;
            return entityObj;
        } catch (Error) {
            throw Error;
        }
    }

    public convertEntityToDto(entityObject: GradeSuggestion): GradeSuggestionDTO {
        const dtoObj= new GradeSuggestionDTO;
        dtoObj.gradeSuggestionId = entityObject.gradeSuggestionId;
        dtoObj.minGrade = entityObject.minGrade;
        dtoObj.maxGrade = entityObject.maxGrade;
        dtoObj.productId = entityObject.productId;
        dtoObj.plantId = entityObject.plantId;
        dtoObj.date = entityObject.date;
        dtoObj.priority = entityObject.priority;
        dtoObj.sequence = entityObject.sequence
        dtoObj.saleOrderId = entityObject.saleOrderId;
        dtoObj.plannedQuantity = entityObject.plannedQuantity;
        dtoObj.isActive = entityObject.isActive;
        dtoObj.createdAt = entityObject.createdAt;
        dtoObj.updatedAt = entityObject.updatedAt;
        dtoObj.createdUser = entityObject.createdUser;
        dtoObj.updatedUser = entityObject.updatedUser;
        dtoObj.versionFlag = entityObject.versionFlag;
        return dtoObj;
      }
}